import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// date, numeri e valute in italiano
registerLocaleData(localeIt);

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));
